import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Home from './components/Home';
import Calendar from './components/Calendar';
import Results from './components/Results';
import Header from './components/Header';
import Footer from './components/Footer';
import FestiveFrame from './components/FestiveFrame';
import pudding from './img/2026/decor-pudding.png';
import bonbon from './img/2026/decor-bonbon.png';
//import FestiveFaceOff from './components/FestiveFaceOff';
//import FestiveFaceOffSignUp from './components/FestiveFaceOffSignUp';
import { getUserData } from './utils/helper';
import UserContext from './utils/userContext';
const EXPIRED_CALENDAR = '2026-12-24T23:59:59';

const App = () => {
    const [userData, setUserData] = useState(null);
    const [userId, setUserId] = useState('');
    const [isSignedUp, setIsSignedUp] = useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const location = useLocation();
    const search = location.search;
    const pathname = location.pathname.replace(/\/+$/, '') || '/';
    const isHome = !isExpired && pathname === '/';
    const isResults = pathname === '/results' || (isExpired && pathname === '/');
    const festivePageClass = isHome
        ? 'home-shell-2026'
        : isResults
            ? 'results-shell-2026'
            : 'calendar-shell-2026';

    useEffect(() => {
        const onLoad = () => document.body.classList.add('loaded');
        if (document.readyState === 'complete') {
          onLoad();
        } else {
          window.addEventListener('load', onLoad);
        }
        return () => window.removeEventListener('load', onLoad);
      }, []);


    useEffect(() => {
        getUserId();
        isExpiredDate();
    }, []);

    // useEffect(() => {
    //     if (userId) {
    //         checkIfSignedUp(userId).then(status => {
    //             setIsSignedUp(status);
    //         });
    //     }
    // }, [userId]);

    // useEffect(() => {
    //     if (userId !== '') {
    //         getUserData(userId)
    //             .then(data => {
    //                 if (data && data.length > 0) {
    //                     setUserData(data)
    //                 }
    //             })
    //     }
    // }, [userId]);

    const isExpiredDate = () => {
        const now = Date.now();
        if (Date.parse(EXPIRED_CALENDAR) < now) {
           setIsExpired(true);
           //setIsExpired(false); // For testing purposes, set to false to keep calendar active
        }
    }

    const getUserId = () => {
        const username = new URLSearchParams(search).get('username');
        if (username !== null) {
            setUserId(username);
        }
    };

    const routes = (
        <Routes>
            {isExpired ? (
                <Route path="/" element={<Results isExpired={isExpired} />} />
            ) : (
                <>
                    <Route exact path="/" element={<Home />} />
                    <Route path="/calendar" element={<Calendar userData={userData} setUserData={setUserData} />} />
                    <Route path="/results" element={<Results />} />
                    {/* <Route path="/festive-face-off" element={<FestiveFaceOff />} />
                    <Route path="/festive-face-off/sign-up" element={<FestiveFaceOffSignUp />} /> */}
                </>
            )}
            <Route path="*" element={<Navigate to={isExpired ? "/" : "/calendar"} replace />} />
        </Routes>
    );

    return (
        <UserContext.Provider value={{ userId, isSignedUp, setIsSignedUp }}>
            <div className="festive-skin" aria-hidden="true" />
            <div className={`app-shell-2026 ${festivePageClass}`}>
                <FestiveFrame variant={isHome ? 'home' : 'calendar'}>
                    <Header isExpired={isExpired} isHome={isHome} />
                    {routes}
                </FestiveFrame>
                <Footer decoration={
                    isHome
                        ? <img className="festive-decor festive-decor-pudding" src={pudding} alt="" />
                        : !isResults
                            ? <img className="festive-decor festive-decor-bonbon calendar-footer-bonbon" src={bonbon} alt="" />
                            : null
                } />
            </div>
        </UserContext.Provider>
    );
}

export default App;
